/* ------------------------------------------ GRYFF ROW - Chris 07.07.2016 ----------------------------------------- */
import HELPER from '@/app/utils/HELPER';
import { initAce, copyToClipboard } from '@/app/utils/HELPER';
import { listForms } from '@/app/utils/helpers';
import utils from '@/app/utils/gfUtils';
import atom from '@/app/editor/iframe/atom';
import store from '@/app/store/store';
import { validateInput } from '@/app/editor/sidebar/utils/validateInput.ts';
import { app } from '@/store';
import { mutations } from '@modules/libraries/store/types';
import { checkKeyValid } from '@/app/utils/checkRoleApply.ts';
import { base, rowTypes, moduleTypes, elementTypes, SCROLL_VIEW_KEY } from './constant';
import { getKeyFromModuleName } from '@/app/utils/moduleKeyName';
import { getGlobalVariable } from '@/app/editor/config/globalVariable';
import { removeElement } from '@/modules/gem-meter';
import emitter from '@/emitter';
import storeX from '@/store';
import { handleAddToLibrary } from './utils/validateAddToLibrary';
import { EDITOR_EVENT } from '@/app/editor/config/constants/trackEventIds';

(function (jQuery) {
  jQuery.gfRow = function (element, options) {
    const defaults = {};
    this.settings = {};
    const _this = this;
    const $element = jQuery(element);

    const _mdEditor =
      '<div id="md-editor" class="md-modal md-draggable">' +
      '<div class="md-content">' +
      '<div class="md-modal-handle">' +
      '<span class="md-title">' +
      '<span gf-tag="title">Code Editor</span>' +
      '<span gf-tag="type" gf-action="click:copyToClipboard" title="Click to copy"></span>' +
      '</span>' +
      '</div>' +
      '<div class="md-body code-panel">' +
      '<div class="section" gf-tabs="coding">' +
      '<div class="section-item disabled" gf-tab="template">Template</div>' +
      '<div class="section-item disabled" gf-tab="style">CSS</div>' +
      '<div class="section-item disabled" gf-tab="script">Script</div>' +
      '</div>' +
      '<textarea id="templateCode" class="inptxt"></textarea>' +
      '<textarea id="styleCode" class="inptxt"></textarea>' +
      '<textarea id="scriptCode" class="inptxt"></textarea>' +
      '</div>' +
      '<div class="md-footer">' +
      '<button class="btnSave">Save</button>' +
      '<button class="btnCancel" class="cancel">Cancel</button>' +
      '</div>' +
      '</div>' +
      '<div class="md-controls">' +
      '<button class="btnClose"><i class="fa fa-times" aria-hidden="true"></i></button>' +
      '</div>' +
      '</div>';

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $divContentHidden = jQuery('#divContentHidden');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();
    const $divContentBk = $gfFrame.contents().find('#divContentBk');

    /* Style */
    const $rowStyleContainer = $gfFrame.contents().find('#' + rowTypes._rowStyleContainer);
    const $columnStyleContainer = $gfFrame.contents().find('#' + rowTypes._columnStyleContainer);

    const $moduleStyleContainer = getGlobalVariable('gfFrameContents').find('#' + moduleTypes._moduleStyleContainer);
    const $moduleScriptContainer = getGlobalVariable('gfFrameContents').find('#' + moduleTypes._moduleScriptContainer);

    const $elementStyleContainer = $gfFrame.contents().find('#' + elementTypes._elementStyleContainer);

    this.init = function () {
      // TODO(thanhdx): add class global style for row
      this.settings = jQuery.extend({}, defaults, options);

      const label = _this.getRowName();
      if (label !== '') {
        const rowId = _this.getRowId();
        let existingContent = '';

        const key = `${base._snippet}-row-${rowId}`;
        const elmData = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](key);
        let $snippet;
        if (!elmData) {
          const storeSnippet = app.$store.getters['editor/GET_SNIPPETS_BY_KEY'](_this.getRowKey());
          if (_this.settings.snippet) {
            $snippet = jQuery(_this.settings.snippet);
          } else {
            $snippet = jQuery('<div />').html(storeSnippet).children();
            existingContent = $element.html();
          }
          const snippet = $snippet.html();
          const icon = $snippet.attr('data-icon') ? $snippet.attr('data-icon') : 'images/icons/default.png';
          _this.initWithSnippet(label, rowId, icon, snippet, existingContent);
        }

        _this.refresh();
      }
      return false;
    };

    this.initWithSnippet = function (label, rowId, icon, snippet, existingContent) {
      $element
        .attr('id', 'r-' + rowId)
        .addClass('gf_row')
        .attr('data-label', label)
        .attr('data-icon', icon)
        .attr('data-id', rowId);

      const $snippet = jQuery('<div>' + snippet + '</div>');
      const $template = $snippet.find('.template');
      const $style = $snippet.find('.style');

      let style = $style.html();
      if (style) {
        style = style.replace(/{{(\S*\s+)?row-id(\S*\s+)?}}/g, rowId);
        $style.html(style);
      }

      let html = '';
      if (existingContent !== '') {
        html = existingContent;
      } else {
        html = $template.html();
      }

      $element.html(html);
      HELPER.addContentBk('<div id="row-' + rowId + '">' + $snippet.html() + '</div>');

      return false;
    };

    this.refresh = function () {
      _this.applyEvents();
      _this.runStyle();

      // clear old class
      $element.removeClass('tool-working tool-viewing');
      $element.find('>.gf_column >.gf_row').each(function () {
        if (jQuery(this).data('gfrow') != undefined) {
          jQuery(this).data('gfrow').refresh();
        } else {
          // jQuery(this).gfRow();
          atom.Init(jQuery(this));
        }
      });
      $element.find('>.gf_column >.module-wrap').each(function () {
        if (jQuery(this).data('gfmodule') != undefined) {
          jQuery(this).data('gfmodule').refresh();
        } else {
          // jQuery(this).gfModule();
          atom.Init(jQuery(this));
        }
      });
      $element.find('>.gf_column >.element-wrap').each(function () {
        if (jQuery(this).data('gfelement') != undefined) {
          jQuery(this).data('gfelement').refresh();
        } else {
          // jQuery(this).gfElement();
          atom.Init(jQuery(this));
        }
      });

      HELPER.generatePlaceholderForm($element);
      return false;
    };

    this.refreshChildParallax = function () {
      // refresh parallax
      if ($element.find('[data-label="Parallax"]').length > 0) {
        $element.find('[data-label="Parallax"]').each(function () {
          jQuery(this).data('gfmodule').refresh();
        });
      }
      return false;
    };

    this.initRowTool = function () {
      if ($element.children('.gf-tool-wrap').length == 0 && !$element.hasClass('gf_row_no_tools')) {
        const _rowTool =
          '<ul class="gf-tool gf-r-tool gf-tool-wrap gf-r-tool-wrap"><li class="t-handle"><a class="r-handle"><span><svg class="editor move" width="14" viewBox="0 0 14 14"><path d="M11,10V8H8v3h2l-3,3l-3-3h2V8H3v2L0,7l3-3v2h3V3H4l3-3l3,3H8v3h3V4l3,3L11,10z"/></svg></span><span class="gf-tool-label">Row</span></a></li><li class="t-wrap r-wrap"><a class="r-export" title="Save row" onclick="return false;"><svg class="editor save" width="14" height="14" viewBox="0 0 14 14"><path d="M12.2499 9.78559V12.4106H1.74999V9.78559H0V12.4106C0 13.3731 0.787495 14.1606 1.74999 14.1606H12.2499C13.2124 14.1606 13.9999 13.3731 13.9999 12.4106V9.78559H12.2499ZM11.3749 6.28561L10.1412 5.05187L7.87495 7.30935V0.160645H6.12496V7.30935L3.85873 5.05187L2.62498 6.28561L6.99996 10.6606L11.3749 6.28561Z"/></svg></a><a class="r-clone" title="Clone Row" onclick="return false;"><svg class="editor duplicate" width="14" viewBox="0 0 14 14"><path d="M10,10H0V0h10V10z M12,4v8H4v2h10V4H12z"/></svg></a><a class="r-remove" title="Remove Row"><svg class="editor delete" width="14" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7c0,3.9,3.1,7,7,7s7-3.1,7-7C14,3.1,10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4 L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z"/></svg></a></li><li class="t-collapse"><a title="Expand / Collapse"><svg class="editor expand" width="8" viewBox="0 0 8 14"><path d="M1,3l4,4l-4,4V3z"/></svg></a></li></ul>';
        $element.append(_rowTool);
      }
      $element.children('.gf_column').each(function () {
        const $that = jQuery(this);

        if ($that.children('.gf_add-content').length == 0) {
          $that.append(window._addContentBtn);
        }

        if ($that.attr('id') == undefined) {
          const colId = _this.getColumnId($that);
          $that.attr('id', 'c-' + colId).attr('data-id', colId);

          const bkColHtml =
            '<div id="column-' +
            colId +
            '"><style rel="stylesheet" class="style" type="text/css">#c-' +
            colId +
            ' {\n}</style></div>';
          HELPER.addContentBk(bkColHtml);
        }
      });

      $element.off('mouseleave.tool').on('mouseleave.tool', function (e) {
        if ($element.hasClass('gf_row') && $element.data('gfrow') != undefined) {
          $element.data('gfrow').hideTool();
        }
      });
      return false;
    };

    // gfRow.applyEvents
    this.applyEvents = function () {
      _this.initRowTool();
      _this.applyButtonActions();
      _this.applyDrag();

      // apply functions
      if ($element.data('gfoutline') != undefined) {
        $element.data('gfoutline').initOutline();
        $element.data('gfoutline').applyOutline();
      } else {
        $element.gfOutline();
      }

      return false;
    };

    this.applyButtonActions = async function () {
      const $rToolWrap = $element.children('.gf-tool-wrap');
      const $cToolWrap = $element.children('.gf_column').children('.gf-tool-wrap');

      // effect click title
      $rToolWrap
        .find('.t-handle .gf-tool-label')
        .off('mousedown.scale')
        .on('mousedown.scale', function () {
          $rToolWrap.addClass('gf-tool-active');
          setTimeout(function () {
            $rToolWrap.removeClass('gf-tool-active');
          }, 100);
        });

      // action buttons
      $rToolWrap
        .find('.t-collapse')
        .off('click')
        .on('click', function () {
          const $tool = jQuery(this).closest('.gf-tool');
          if ($tool.hasClass('gf-expand')) {
            $tool.removeClass('gf-expand');
          } else {
            const $toolWrap = jQuery(this).closest('.gf-tool-wrap');
            $toolWrap.find('.gf-tool').removeClass('gf-expand');
            $tool.addClass('gf-expand');
          }

          return false;
        });

      $cToolWrap
        .find('.t-collapse')
        .off('click')
        .on('click', function () {
          const $tool = jQuery(this).closest('.gf-tool');
          if ($tool.hasClass('gf-expand')) {
            $tool.removeClass('gf-expand');
          } else {
            const $toolWrap = jQuery(this).closest('.gf-tool-wrap');
            $toolWrap.find('.gf-tool').removeClass('gf-expand');

            $tool.addClass('gf-expand');
          }

          return false;
        });

      $rToolWrap
        .add($cToolWrap)
        .find('.r-remove')
        .off('click')
        .on('click', function (e) {
          // Close all setting
          if ($gfLeftSideBar.find('#md-settings').parent().hasClass('vhr')) {
            $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
          }
          $element.fadeOut(300, function () {
            _this.doRemoveMe();
          });
          return false;
        });

      // export row
      $rToolWrap
        .add($cToolWrap)
        .find('.r-export')
        .off('click')
        .on('click', async function () {
          await handleAddToLibrary($element);
          // app.$store.commit(`library/${mutations.OPEN_CREATE_LIB}`, { type: 'block', target: $element });
          return false;
        });

      // clone row
      $rToolWrap
        .add($cToolWrap)
        .find('.r-clone')
        .off('click')
        .on('click', function () {
          _this.cloneMe();
          return false;
        });

      $rToolWrap
        .add($cToolWrap)
        .off('click')
        .on('click', '.c-edit,.c-handle:not(".gf-icon")', function () {
          const $activeColumn = jQuery(this).closest('.gf_column');
          _this.openColumnSettings($activeColumn);
          return false;
        });
    };

    // gfRow.showTool
    this.showTool = function (force) {
      let showTool = true;
      if (!force) {
        if ($gryffEditor.data('gryffeditor').isDragging() || $gryffEditor.data('gftexteditor').isEditing($element)) {
          showTool = false;
        }
      } else {
        showTool = true;
      }
      if (showTool) {
        const paddingTop = parseInt($element.css('paddingTop'));
        const $rToolWrap = $element.children('.gf-tool-wrap');
        $rToolWrap.addClass('gf-tool-show');

        if ($element.data('gfoutline') != undefined) {
          $element.data('gfoutline').showOutline();
        }
      }
      return false;
    };
    // gfRow.showToolAndOutlineForDragdrop
    this.showToolAndOutlineForDragdrop = function () {
      const $rToolWrap = $element.children('.gf-tool-wrap');
      $rToolWrap.addClass('gf-tool-show');
      if ($element.data('gfoutline') != undefined) {
        $element.data('gfoutline').showOutline();
      }
    };
    // gfRow.hideTool
    this.hideTool = function (force) {
      if (
        !window._isContextOpenned ||
        ($gryffBody.data('gfcontextmenu') &&
          $gryffBody.data('gfcontextmenu').getTargetMERId() != $element.attr('id')) ||
        force == true
      ) {
        if (!$gryffEditor.data('gryffeditor').isDragging() || force == true) {
          const $rToolWrap = $element.children('.gf-tool-wrap');
          $rToolWrap.removeClass('gf-tool-show');
          if ($element.data('gfoutline') != undefined) {
            $element.data('gfoutline').hideOutine();
          }
        }
      }
      $element.removeClass('gf_primary-tool');

      return false;
    };

    this.showColTool = function ($column) {
      $column.addClass('gf-mer-active');
      return false;
    };
    this.hideColTool = function ($column) {
      $column.removeClass('gf-mer-active');
      return false;
    };

    this.highlightCounter = function (rowId) {
      app.$store.commit('sidebar/SET_SIDE_BAR_SETTING_ELEMENT_ID', {
        merId: rowId,
        type: 'row',
      });
      const $mdSettings = $gfLeftSideBar.find('#md-settings');
      let _counter = $mdSettings.attr('hightlight-counter');
      if (!_counter) {
        _counter = 'id,number';
      }
      const $arrayCounter = _counter.split(',');
      const _id = $arrayCounter[0];
      let _number = $arrayCounter[1];

      if (rowId != _id) {
        _number = 1;
      } else {
        _number = parseInt(_number) + 1;
      }
      $mdSettings.attr('hightlight-counter', rowId + ',' + _number);
      return _number;
    };

    this.openRowSettings = function (tab, drag, capture) {
      const doOpenRowSettings = function () {
        if (tab) {
          const arrayTab = tab.split(':');
          tab = arrayTab[0];
          var columnOpen = arrayTab[1];
        }

        $gfLeftSideBar.data('gfleftsidebar').showHighlighter('row-panel');
        const rowId = _this.getRowId();

        // Đếm số lượt mở open setting để cảnh báo đến người dùng.
        if (drag == undefined) {
          drag = false;
        }
        if (!drag) {
          const _countHighlight = _this.highlightCounter(rowId);
          if (_countHighlight >= 3 && _countHighlight < 5) {
            const $hightlight = jQuery('<div class="gf_panel-hightlight-all row-panel"></div>');
            $gfLeftSideBar.find('.side-panels').append($hightlight);
            setTimeout(function () {
              $hightlight.remove();
            }, 1000);
          }
        }

        // avoid 3 times open
        const $mdSettings = $gfLeftSideBar.find('#md-settings');
        const currentTab = $mdSettings.find('.simple-tabs ul.simple-tabs-item li.active').text().trim();
        const newTab = tab ? tab : 'Settings';
        const merId = $mdSettings.data('edittingID');
        if ($mdSettings.hasClass('active') && merId == $element.attr('id') && currentTab == newTab) {
          app.$store.commit('sidebar/CHANGE_ACTIVE_TAB', {
            key: 'elements',
          });
          return false;
        }

        const $bkActiveRow = $divContentBk.find('#row-' + rowId);
        const $style = $bkActiveRow.find('.style');

        let $gfTabs;
        let $activeModal;

        const html =
          '<div id="md-row"><span class="md-title"><span class="mer-title"><i class="gpicon-row"></i> Row </span><span></span></span><div class="simple-tabs"><ul class="simple-tabs-item"><li><a href="#">' +
          utils.svgIcon('settings') +
          ' Settings </a></li><li><a href="#">' +
          utils.svgIcon('design') +
          ' Design </a></li></ul><div class="md-body general-panel"></div><div class="md-body design-panel"></div></div><div class="md-footer"><button class="btnSave">Apply</button><button class="btnCancel">Cancel</button></div></div>';
        const settings = [
          {
            name: 'gf_row-layout-md',
            id: 'gf_row-layout-md',
            type: 'text',
            class: 'gf_row-layout-md no-render',
            value: '',
          },
          {
            name: 'gf_row-layout-sm',
            id: 'gf_row-layout-sm',
            type: 'text',
            class: 'gf_row-layout-sm no-render',
            value: '',
          },
          {
            name: 'gf_row-layout-xs',
            id: 'gf_row-layout-xs',
            type: 'text',
            class: 'gf_row-layout-xs no-render',
            value: '',
          },
          {
            name: 'gf_row-layout',
            id: 'gf_row-layout',
            caption: 'Column Size Customizer',
            type: 'text',
            class: 'gf_row-layout',
            value: '',
            desc: '',
            advanced: [
              {
                name: 'column_size_resizer',
                id: 'column_size_resizer',
                class: 'column-size-resizer',
                caption: 'Column Size Resizer',
                default_value: '',
              },
            ],
          },
          {
            id: 'full_width',
            name: 'row-type',
            class: 'gf_to-switch',
            caption: 'Full Width',
            type: 'text',
            desc: 'Select stretching options for row and content.',
          },
          // {
          //     "caption": "Positioning",
          //     "type": "group",
          //     "mode": "responsive-mode",
          //     "class": "gf_row",
          //     "items": [
          //         {
          //             "name": "position",
          //             "id": "position",
          //             "caption": "Position",
          //             "type": "select",
          //             "options": {
          //               "static": "Static",
          //               // "relative": "Relative",
          //               // "absolute": "Absolute",
          //               "fixed": "Sticky to the screen (Fixed)",
          //               // "sticky": "Sticky",
          //             },
          //             "default_value": "static",
          //             "mode": "responsive-mode",
          //             "target": ".gf_row",
          //             "ref": "css|position"
          //         },
          //         {
          //           "name": "zIndex",
          //           "id": "zIndex",
          //           "caption": "Z-Index",
          //           "type": "number",
          //           "default_value": "0",
          //           "mode": "responsive-mode",
          //           "target": ".gf_row",
          //           "ref": "css|z-index"
          //       }
          //     ]
          // },
          {
            caption: 'Dimension (Width)',
            type: 'group',
            mode: 'responsive-mode',
            class: 'gf_row',
            items: [
              {
                name: 'width',
                requires: 'full_width|0',
                id: 'row_width',
                caption: 'Width',
                type: 'text',
                unit: 'px',
                default_value: '1200',
                mode: 'responsive-mode',
                target: '.gf_row-wrap',
                ref: 'css|width',
              },
            ],
          },
          {
            name: 'columns_gap',
            class: 'gf_to-range',
            caption: 'Columns Gap',
            type: 'text',
            min: '0',
            max: '150',
            step: '1',
            unit: 'px',
            requires: 'full_width|0',
          },
          {
            caption: 'Height & Vertical Align',
            type: 'group',
            items: [
              {
                name: 'equal_height',
                id: 'equal_height',
                class: 'gf_to-switch',
                caption: 'Equal Height',
                type: 'text',
                desc: 'If checked columns will be set to equal height.',
              },
              {
                id: 'vertical_align',
                name: 'vertical_align',
                caption: 'Vertical Align',
                desc: 'Vertical Align items inside Row',
                type: 'select',
                options: {
                  top: 'Top',
                  middle: 'Middle',
                  bottom: 'Bottom',
                },
                requires: 'equal_height|1',
                default_value: 'top',
              },
            ],
          },
          {
            name: 'extra_class',
            caption: 'Extra class name',
            type: 'text',
            desc: 'If you wish to style particular content element differently, then use this field to add a class name and then refer to it in your css file.',
          },
        ];

        const $activePanel = $gfLeftSideBar
          .data('gfleftsidebar')
          .showMDSettingsPanel('row', html, $element.attr('id'), 'md-settings');

        const fields = settings;

        const $settingsPanel = $gfLeftSideBar.find('#md-row .md-body.general-panel');
        $settingsPanel.gfFormRender({
          fields: fields,
          onRender: function () {},
        });

        // reload Tabs
        $gfTabs = $activePanel.find('.simple-tabs');
        $gfTabs.gfTabs({
          targetElement: $element,
          onSettingsChanged: function ($input) {
            saveSettings($input);
          },
          onTabClick: function (tabName) {
            switch (tabName) {
              case 'Settings':
                var style = _this.getRowCSS();
                var $gfResTool = jQuery('#gfResTool');
                var screenType =
                  $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

                // set row layout
                var cText = _this.getRowLayout();
                $activePanel.find('.gf_row-layout').attr('value', cText).val(cText);

                // class gf_row_container-fluid lỗi, trường hợp khách nào đã dùng thì check
                if ($element.hasClass('gf_row-fluid') || $element.hasClass('gf_row_container-fluid')) {
                  var rowLayout = 1;
                } else {
                  var rowLayout = 0;
                }
                $activePanel.find('input[name="row-type"]').val(rowLayout).attr('value', rowLayout);

                var equalHeight = $element.hasClass('gf_equal-height') ? 1 : 0;
                $activePanel.find('input[name="equal_height"]').val(equalHeight).attr('value', equalHeight);

                // Columns gap
                var gap = $element.attr('data-row-gap');
                if (gap == undefined) {
                  gap = $element.children('.gf_column').css('padding-left');
                }
                $activePanel
                  .find('input[name="columns_gap"]')
                  .val(parseInt(gap) + 'px')
                  .attr('value', parseInt(gap) + 'px');

                // set width row
                var maxWidth = HELPER.getValueFromCSS($element, style, 'max-width', screenType, '.gf_row');
                if (!maxWidth || maxWidth == 'none') {
                  switch (screenType) {
                    case 'lg': {
                      maxWidth = '1200px';
                      break;
                    }
                    case 'md':
                    case 'sm':
                    case 'xs': {
                      maxWidth = '100%';
                      break;
                    }
                  }
                }
                $activePanel
                  .find('#row_width')
                  .attr('value', maxWidth)
                  .val(maxWidth)
                  .trigger('value-change')
                  .trigger('input-change');

                var extraClass = $element.attr('data-extraClass') ? $element.attr('data-extraClass') : '';

                $activePanel.find('input[name="extra_class"]').val(extraClass).attr('value', extraClass);

                // Read Setting VerticalAlign
                // New equal-height
                if ($element.css('display') == 'flex') {
                  const verticalAlign = $element.children('.gf_column').css('justify-content');
                  let verticalValue;
                  if (verticalAlign == 'flex-start') {
                    verticalValue = 'top';
                  } else if (verticalAlign == 'center') {
                    verticalValue = 'middle';
                  } else if (verticalAlign == 'flex-end') {
                    verticalValue = 'bottom';
                  }
                  if (verticalAlign) {
                    $activePanel.find('select[name="vertical_align"]').val(verticalAlign).attr('value', verticalAlign);
                  }
                  if (verticalValue) {
                    $activePanel.find('select[name="vertical_align"]').val(verticalValue).attr('value', verticalValue);
                  }
                } else {
                  // Old equal-height
                  const verticalClass = $element.find('.gf_column').attr('class');
                  if (verticalClass) {
                    const matches = verticalClass.match(/gf_vertical-(\w*)/);
                    if (matches && matches.length > 0) {
                      const verticalValue = matches[1];
                      $activePanel
                        .find('select[name="vertical_align"]')
                        .val(verticalValue)
                        .attr('value', verticalValue);
                    }
                  }
                }

                setTimeout(function () {
                  // Phục vụ cho onboarding;
                  $activePanel.trigger('load-settings-success');
                }, 100);
                break;

              case 'Design':
                if ($gfTabs.data('gftabs') != undefined) {
                  $gfTabs.data('gftabs').onDesignOptionsTabClick();
                }
                break;
            }

            setTimeout(function () {
              // capture history setting
              if (capture != false) {
                $gryffEditor.data('gfhistory').captureMERSettings();
              }
            }, 100);
          },
        });

        if (tab != undefined && tab == 'Design') {
          $gfTabs.data('gftabs').gotoTab(1);
        }

        var saveSettings = function ($input) {
          validateInput($input);
          // var targetClass = '.gf_row';
          const targetClass = '';
          const _addClass = [],
            _removeClass = [];
          let style = _this.getRowCSS();
          const $gfResTool = jQuery('#gfResTool');
          const screenType =
            $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
          if ($activePanel.find('input[name="row-type"]').val() == '1') {
            _addClass.push('gf_row-fluid gf_row-no-padding');

            const deOptions = [
              {
                key: 'max-width',
                value: 'none',
              },
            ];

            // Clear hết max-width ở tất cả các screen
            const allScreens = ['lg', 'md', 'sm', 'xs'];
            allScreens.forEach((screen) => {
              style = HELPER.designOptions2Style($element, screen, style, deOptions, targetClass);
            });
          } else {
            _removeClass.push('gf_row-fluid');
            // class này lỗi, xóa đi cho trường hợp khách hàng đã dùng class này
            _removeClass.push('gf_row_container-fluid');
            _removeClass.push('gf_row-no-padding');
            // change layout row
            const inputId = $input.attr('id');
            switch (inputId) {
              case 'gf_row-layout': {
                const layOut = $activePanel.find('.gf_row-layout').val();
                $element.attr('data-layout-lg', layOut);
                break;
              }
              case 'gf_row-layout-md': {
                const layOut = $activePanel.find('.gf_row-layout-md').val();
                $element.attr('data-layout-md', layOut);
                break;
              }
              case 'gf_row-layout-sm': {
                const layOut = $activePanel.find('.gf_row-layout-sm').val();
                $element.attr('data-layout-sm', layOut);
                break;
              }
              case 'gf_row-layout-xs': {
                const layOut = $activePanel.find('.gf_row-layout-xs').val();
                $element.attr('data-layout-xs', layOut);
                break;
              }
            }
            // Truong hop tat full_width
            if ($input.attr('id') == 'full_width') {
              let customMaxWidth = '1200px';
              const allScreens = ['lg', 'md', 'sm', 'xs'];
              // Cap nhat lai style default
              allScreens.forEach((screen) => {
                switch (screen) {
                  case 'lg': {
                    customMaxWidth = '1200px';
                    break;
                  }
                  case 'md':
                  case 'sm':
                  case 'xs': {
                    customMaxWidth = '100%';
                    break;
                  }
                }
                const deOptions = [
                  {
                    key: 'max-width',
                    value: customMaxWidth,
                  },
                ];
                style = HELPER.designOptions2Style($element, screen, style, deOptions, targetClass);
              });

              switch (screenType) {
                case 'lg': {
                  customMaxWidth = '1200px';
                  break;
                }
                case 'md':
                case 'sm':
                case 'xs': {
                  customMaxWidth = '100%';
                  break;
                }
              }
              $activePanel
                .find('input[name=width]')
                .attr('value', customMaxWidth)
                .val(customMaxWidth)
                .trigger('value-change');
            } else {
              const customMaxWidth = $activePanel.find('input[name=width]').val();
              const deOptions = [
                {
                  key: 'max-width',
                  value: customMaxWidth,
                },
              ];
              style = HELPER.designOptions2Style($element, screenType, style, deOptions, targetClass);
            }
          }

          _this.setRowCSS(style);

          // Read Style Vertical Align
          if ($input.attr('name') == 'gf_row-layout') {
            if ($element.css('display') === 'flex') {
              _this.setFlexDirection(style, $element, screenType);
            }
          }
          if ($input.attr('name') == 'vertical_align') {
            // New vertical align
            if ($element.css('display') === 'flex') {
              var vertical_align = $activePanel.find('select[name="vertical_align"]').attr('value');
              switch (vertical_align) {
                case 'middle': {
                  $element.children('.gf_column').css('justify-content', 'center');
                  break;
                }
                case 'bottom': {
                  $element.children('.gf_column').css('justify-content', 'flex-end');
                  break;
                }
                default: {
                  $element.children('.gf_column').css('justify-content', 'flex-start');
                }
              }
              _this.setFlexDirection(style, $element, screenType);
            } else {
              // Old vertical align ( điểm khác nhau là còn tồn tại min-height của column)
              const verticalValue = $input.val();
              if (verticalValue) {
                $element.find('.gf_column').removeClass(function (index, className) {
                  return (className.match(/gf_vertical-\w*/g) || []).join(' ');
                });
                if (verticalValue != 'top') {
                  $element.find('.gf_column').addClass('gf_vertical-' + verticalValue);
                }
              }
            }
          }

          if ($activePanel.find('input[name="equal_height"]').val() == '1') {
            _addClass.push('gf_equal-height');
            if ($input.attr('id') == 'equal_height') {
              _this.switchDisplay(style, $element, 'flex');
              $element.children('.gf_column').each(function () {
                const $column = jQuery(this);
                $column.children('.gf_column').css('min-height', '1px');
                $column.css('display', 'flex');
                $column.css('flex-direction', 'column');
              });
              var vertical_align = $activePanel.find('select[name="vertical_align"]').attr('value');
              switch (vertical_align) {
                case 'middle': {
                  $element.children('.gf_column').css('justify-content', 'center');
                  break;
                }
                case 'bottom': {
                  $element.children('.gf_column').css('justify-content', 'flex-end');
                  break;
                }
                default: {
                  $element.children('.gf_column').css('justify-content', 'flex-start');
                }
              }
              _this.setFlexDirection(style, $element, screenType);
            }
          } else {
            _removeClass.push('gf_equal-height');
            // $element.css("display","block");
            if ($input.attr('id') == 'equal_height') {
              _this.switchDisplay(style, $element, 'block');
              $element.find('.gf_column').each(function () {
                const $column = jQuery(this);
                $column.find('.gf_column').css('min-height', '1px');
                $column.css('display', 'block');
                $column.css('flex-direction', 'unset');
                $column.css('justify-content', 'unset');
              });
              $element.children('.gf_column').css('justify-content', 'unset');
            }
            // Remove vertical when disable equal height
            $element.find('.gf_column').removeClass(function (index, className) {
              return (className.match(/gf_vertical-\w*/g) || []).join(' ');
            });
          }

          //Columns gap
          let _hasGap = false;
          $element.removeClass(function (index, css) {
            if (css.match(/(^|\s)gf_row-gap-+[0-9]+(?=($|\s))+/g)) {
              _hasGap = true;
            }
            return (css.match(/(^|\s)gf_row-gap-+[0-9]+(?=($|\s))+/g) || []).join(' ');
          });
          const gap = $activePanel.find('input[name="columns_gap"]').val();
          if (_hasGap || parseInt(gap) != 15) {
            $element.attr('data-row-gap', parseInt(gap) + 'px').addClass('gf_row-gap-' + parseInt(gap));
          }

          const oExClass = $element.attr('data-extraClass');
          _removeClass.push(oExClass);

          const nExClass = $activePanel.find('input[name="extra_class"]').val();
          $element.attr('data-extraClass', nExClass);
          _addClass.push(nExClass);

          // update classes
          $element.removeClass(_removeClass.join(' ')).addClass(_addClass.join(' '));

          // refresh parallax
          _this.refreshChildParallax();

          HELPER.refreshFrame();

          //----------------------
          HELPER.flagListItemChange($element, 'replace');

          const $itemContent = $element.closest('.item-content');
          HELPER.detectContentChange($itemContent);

          return false;
        };

        if (columnOpen && columnOpen != '') {
          $gfLeftSideBar.find('.columns[data-caption="' + columnOpen + '"]').attr('data-toggle', 'true');
        }

        app.$store.commit('sidebar/CHANGE_ACTIVE_TAB', {
          key: 'elements',
        });
      };
      // Execute function

      const presetIsEdited = app.$store.getters['sidebar/PRESET_IS_EDITED'];
      if (presetIsEdited) {
        emitter.emit('WithoutPresetEdited');
        emitter.on('CallBackWithoutPresetEdited', () => {
          doOpenRowSettings();
        });
      }

      if (presetIsEdited) return false;
      doOpenRowSettings();
      return false;
    };

    this.getRowLayout = function () {
      let rowTypeString;
      let rowType = [];

      $element.children('.gf_column').each(function () {
        const $column = jQuery(this);

        let data = _this.getColumn($column, 'size', 'lg');
        if (jQuery.isEmptyObject(data)) {
          data = _this.getColumn($column, 'size', 'md');
        } else if (jQuery.isEmptyObject(data)) {
          data = _this.getColumn($column, 'size', 'sm');
        } else if (jQuery.isEmptyObject(data)) {
          data = _this.getColumn($column, 'size', 'xs');
        }
        if (jQuery.isEmptyObject(data)) {
          data = {
            type: 'size',
            screen: 'lg',
            value: '12',
          };
        }
        rowType.push(data.value);
      });
      if (rowType.length == 0) {
        rowType = ['12'];
      }
      rowTypeString = rowType.join('+');

      if (!rowTypeString) {
        rowTypeString = '12';
      }
      return rowTypeString;
    };

    this.getAllRowLayout = function ($element) {
      let data = {};

      $element.children('.gf_column').each(function () {
        const $column = jQuery(this);
        const dataLg = _this.getColumn($column, 'size', 'lg') || {};
        const dataMd = _this.getColumn($column, 'size', 'md') || {};
        const dataSm = _this.getColumn($column, 'size', 'sm') || {};
        const dataXs = _this.getColumn($column, 'size', 'xs') || {};
        data = {
          lg: dataLg.value,
          md: dataMd.value,
          sm: dataSm.value,
          xs: dataXs.value,
        };
      });

      return data;
    };

    this.setRowLayout = function (cText) {
      const cTextArray = cText.split('+');

      if (cTextArray.length > 0) {
        cTextArray.forEach(function (item, index) {
          cTextArray[index] = parseInt(item);
          if (isNaN(cTextArray[index]) || cTextArray[index] < 1 || cTextArray[index] > 12) {
            HELPER.showNotify('Invalid Input', 'error');
            return;
          }
        });

        const screenType = 'lg';

        const columnsOld = $element.children('.gf_column').length;
        const columnsNew = cTextArray.length;
        if (columnsOld === columnsNew) {
          $element.children('.gf_column').each(function (index) {
            const $thisColumn = jQuery(this);
            _this.setColumn($thisColumn, 'size', screenType, cTextArray[index]);
          });
        } else if (columnsOld > columnsNew) {
          var htmlTmp = '';
          const rmList = [];

          for (var i = 1; i <= columnsOld - columnsNew; i++) {
            $element
              .children('.gf_column:eq(' + columnsNew + ')')
              .children('.gf_add-content, .c-tool')
              .remove();
            htmlTmp += $element.children('.gf_column:eq(' + columnsNew + ')').html();

            const $rm = $element.children('.gf_column:eq(' + columnsNew + ')');
            rmList.push('#' + $rm.attr('id').replace('c-', 'column-'));

            $element.children('.gf_column:eq(' + columnsNew + ')').remove();
          }
          const $lastCol = $element.children('.gf_column:eq(' + (columnsNew - 1) + ')');
          $lastCol.children('.gf_add-content').before(htmlTmp);

          $element.children('.gf_column').each(function (index) {
            const $thisColumn = jQuery(this);
            _this.setColumn($thisColumn, 'size', screenType, cTextArray[index]);
          });
          $divContentBk.find(rmList.join(',')).remove();
        } else {
          var htmlTmp = '';
          for (var i = 1; i <= columnsNew - columnsOld; i++) {
            htmlTmp += '<div class="gf_column">' + window._addContentBtn + '</div>';
          }
          $element.children('.gf_column:last').after(htmlTmp);

          $element.children('.gf_column').each(function (index) {
            const $thisColumn = jQuery(this);
            _this.setColumn($thisColumn, 'size', screenType, cTextArray[index]);
          });
        }

        // refresh parallax
        _this.refreshChildParallax();

        // detect element or module change
        const $itemContent = $element.closest('.item-content');
        HELPER.detectContentChange($itemContent);

        _this.refresh();
      }

      return false;
    };

    // gfRow.runStyle
    this.runStyle = function (style) {
      if (!style) {
        style = this.getRowCSSUseStore();
      }

      return this.setRowCSSUseStore(style);
    };

    this.runColumnStyle = function ($column, style) {
      return this.setColumnCSSUseStore();
    };

    // gfRow.applyDrag
    this.applyDrag = function () {
      const $rHandle = $element.children('.gf-tool-wrap').find('.r-handle');
      const $cRHandle = $element.children('.gf_column').children('.gf-tool-wrap').find('.r-handle');

      $rHandle.add($cRHandle).gfDraggable({
        targetElement: $element,
        type: 'row',
        start: function () {
          $rHandle.closest('.gf-tool').removeClass('gf-expand');
          $cRHandle.closest('.gf-tool').removeClass('gf-expand');
          return false;
        },
        stop: function (nearY, $from, $to, $stElement, $dragHidden, notDragging) {
          // notDragging is usually undefinded
          // Xử lý cho trường hợp click event
          if (notDragging) {
            _this.openRowSettings(undefined, true);
            return;
          }

          // Xử lý cho drag event
          if (nearY != undefined) {
            let index = nearY.id;
            if (index < 0) {
              index = 0;
            }
            const $newPlace = window.$gfPlaceHolders.eq(index);
            if ($newPlace.length === 1) {
              $to = $newPlace.closest('.item-content');

              let flag = true;

              //block FORM to FORM
              for (let i = 0; i < listForms.length; i++) {
                if ($stElement && $stElement.find('[data-label="' + listForms[i] + '"]').length) {
                  for (let j = 0; j < listForms.length; j++) {
                    if ($to.closest('[data-label="' + listForms[j] + '"]').length) {
                      flag = false;
                      HELPER.showNotify('Cannot put a ' + listForms[i] + ' inside a ' + listForms[j] + '.', 'error');
                      break;
                    }
                  }
                }
                if (!flag) {
                  break;
                }
              }

              // related products
              if (
                $stElement.attr('data-label') == 'Related Products' ||
                $stElement.find('[data-label="Related Products"]').length > 0
              ) {
                if ($to.closest('[data-label="Product"]').length > 0) {
                  flag = false;
                  HELPER.showNotify('Related Products cannot be dropped inside Product.', 'error');
                }
              }

              // 6, Element chứa (P) không được kéo ra ngoài Product
              if ($stElement && $from.closest('[data-label="Product"]').length > 0) {
                const $moduleElmProduct = $stElement.find(
                  '[data-label="(P) Title"], [data-label="(P) Description"], [data-label="(P) Price"], [data-label="(P) Quantity"], [data-label="(P) Cart Button"], [data-label="(P) Image"], [data-label="(P) Image List"], [data-label="(P) Variants"], [data-label="(P) Swatches"], [data-label="(P) Meta"]',
                );
                if ($moduleElmProduct.length > 0) {
                  if ($to.closest('[data-label="Product"]').length == 0) {
                    flag = false;
                    HELPER.showNotify('You cannot move product child elements out of Product.', 'error');
                  } else if (HELPER.isInsideTheList($to)) {
                    flag = false;
                    HELPER.showNotify('You cannot move product child elements out of Product.', 'error');
                  }
                }
              }

              // 7, Element chứa (A) không được kéo ra ngoài Article
              if ($stElement && $from.closest('[data-label="Article"]').length > 0) {
                const $moduleElmArticle = $stElement.find(
                  '[data-label="(A) Title"], [data-label="(A) Image"], [data-label="(A) Content"], [data-label="(A) Excerpt"], [data-label="(A) Date"]',
                );
                if ($moduleElmArticle.length > 0) {
                  if ($to.closest('[data-label="Article"]').length == 0) {
                    flag = false;
                    HELPER.showNotify('This module contains only fields that exist in the article', 'error');
                  } else if (HELPER.isInsideTheList($to)) {
                    flag = false;
                    HELPER.showNotify('This module contains only fields that exist in the article', 'error');
                  }
                }
              }

              if (flag) {
                $rHandle.data('gfdraggable').manageStop($newPlace, $stElement, $from, $to);
              } else {
                if ($dragHidden) {
                  $dragHidden.after($stElement);
                  window._isDetached = false;
                }
              }
            }
          } else {
            if ($dragHidden) {
              $dragHidden.after($stElement);
              window._isDetached = false;
            }
          }
          if ($dragHidden) {
            $dragHidden.remove();
          }

          _this.openRowSettings(undefined, true);
        },
      });
    };

    this.getRowId = function () {
      let rowId = HELPER.MakeIdInsideList($element);
      if (rowId == '') {
        rowId = $element.attr('data-id') || HELPER.MakeId();
      }
      return rowId;
    };

    this.getRowKey = function () {
      const key = $element.attr('data-key');
      if (key) {
        return key;
      } else {
        const name = _this.getRowName();
        return getKeyFromModuleName(name);
      }
    };

    this.getColumnId = function ($column) {
      let colId = HELPER.MakeIdInsideList($column);
      if (colId == '') {
        colId = $column.attr('data-id') || HELPER.MakeId();
      }
      return colId;
    };

    this.getRowName = function () {
      return $element.attr('data-label') || 'Row';
    };

    this.getRowCSS = function () {
      return this.getRowCSSUseStore();
    };

    this.getRowCSSUseStore = function () {
      const rowId = this.getRowId();
      const key = rowTypes._styleRow + '-' + rowId;
      return app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](key);
    };

    this.getRowCSSUseDom = function () {
      const rowId = this.getRowId();
      const $bkActiveRow = $divContentBk.find('#row-' + rowId);
      const $style = $bkActiveRow.find('.style');
      let style = $style.html();
      if (!style) {
        style = '';
      }

      return style;
    };

    this.setRowCSSUseDom = function (style) {
      style = HELPER.formatCSS(style);
      const rowId = _this.getRowId();

      const $bkActiveRow = $divContentBk.find('#row-' + rowId);
      const $style = $bkActiveRow.find('.style');

      if ($style) {
        $style.html(style);
      } else {
        jQuery('<style class="style">' + style + '</style>').appendTo($bkActiveRow);
      }
      return _this;
    };

    this.setColumnCSSUseStore = function (style) {
      const rowId = _this.getRowId();
      const _style = HELPER.formatCSS(style);
      const $thisElmActive = $columnStyleContainer.find('#' + base._style + '-' + rowId);

      if ($thisElmActive.length === 0) {
        jQuery(`<div id="${base._style}-${rowId}"></div>`).appendTo($rowStyleContainer);
      }

      $thisElmActive.html('<style class="style">' + _style + '</style>');
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: rowTypes._styleColumn + '-' + rowId,
        value: _style,
      });

      return _this;
    };

    this.setRowCSSUseStore = function (style) {
      const rowId = _this.getRowId();
      const _style = HELPER.formatCSS(style);
      const $thisElmActive = $rowStyleContainer.find('#' + base._style + '-' + rowId);

      if ($thisElmActive.length === 0) {
        jQuery(`<div id="${base._style}-${rowId}"></div>`).appendTo($rowStyleContainer);
      }

      $thisElmActive.html('<style class="style">' + _style + '</style>');
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: rowTypes._styleRow + '-' + rowId,
        value: _style,
      });

      return _this;
    };

    this.setRowCSS = function (style) {
      this.setRowCSSUseStore(style);
    };

    this.copyCSS = function () {
      const style = _this.getRowCSS();
      const id = this.getRowId();
      const label = this.getRowName();
      const dataClipBoardCSS = {
        id: id,
        label: label,
        style: style,
      };
      store.setValue('__clipBoardCSS', dataClipBoardCSS);
    };

    this.pasteCSS = function () {
      const clipBoardCSS = store.getValue('__clipBoardCSS') || {};
      const id = this.getRowId();
      const label = this.getRowName();
      if (!jQuery.isEmptyObject(clipBoardCSS) && label == clipBoardCSS.label) {
        const oldStyle = this.getRowCSS();
        let style = clipBoardCSS.style;
        if (id != clipBoardCSS.id) {
          const oldId = new RegExp(clipBoardCSS.id, 'g');
          style = style.replace(oldId, id);
        }
        this.setRowCSS(style);

        HELPER.flagListItemChange($element, 'replace');
        HELPER.detectContentChange($element);
        //add history
        const extra = {
          edit: 'css',
          style: oldStyle,
        };
        if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') != undefined) {
          $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
        }

        this.openRowSettings();
      }
    };

    var templateTrackingTime = 0
    var styleTrackingTime = 0
    var scriptTrackingTime = 0
    var startTrackingTime = Date.now();

    this.rowCSS = function (enableSections = ['style']) {
      $divContentHidden.find('#md-editor').remove();
      $divContentHidden.append(_mdEditor);
      $divContentHidden.find('[gf-tag="title"]').html(`Code Editor - ${$element.attr('data-label')}`);

      const style = _this.getRowCSS();
      const oldStyle = style;

      const $activeModal = jQuery('#md-editor');
      $activeModal.find('#styleCode').hide().val(HELPER.formatCSS(style));
      $activeModal.find('#templateCode').hide();
      $activeModal.find('#scriptCode').hide();
      $activeModal.find('#dataCode').hide();

      var startTrackingTime = Date.now();
      $activeModal.find(`[gf-tabs]>[gf-tab="style"]`).addClass('active is-selected');
      const $cEditor = initAce('styleCode', 'style');
      // huỷ trạng thái disable của những tab được active
      $activeModal.find('[gf-tabs]>[gf-tab]').each(function () {
        const $item = jQuery(this);
        const tab = ($item.attr('gf-tab') || '').toLowerCase();
        if (enableSections.includes(tab)) {
          $item.removeClass('disabled');
        }
      });

      $activeModal.gfModal({
        opacity: 0.4,
        bg: 'rgb(62, 62, 62)',
        zIndex: 9999999,
      });

      const mw = jQuery(window).outerWidth() < 1000 ? jQuery(window).outerWidth() : 1000;

      $activeModal
        .data('gfmodal')
        .setTitle('#r-' + $element.attr('data-id') + utils.svgIcon('copy'))
        .setWidth(mw + 'px')
        // .setHeight('500px')
        .centerModal() //
        .show();

      let __timeout = null;
      // xử lý click vào tag để copy id
      $activeModal
        .find('[gf-action="click:copyToClipboard"]')
        .off('click.clipboard')
        .on('click.clipboard', function () {
          const copied = copyToClipboard('#r-' + $element.attr('data-id'));
          if (copied) {
            const $thisSpan = jQuery(this);
            $thisSpan.parent().find('[gf-span="msg"]').remove();
            clearTimeout(__timeout);
            const $msg = jQuery(`<span gf-span="msg">Copied!</span>`);
            $msg.css({
              color: '#42C184',
              'font-size': '12px',
              'margin-left': '4px',
            });
            $thisSpan.after($msg);
            __timeout = setTimeout(() => {
              $thisSpan.next('span').remove();
            }, 1500);
          }
        });

      $activeModal
        .find('.btnSave')
        .off()
        .on('click', function () {
          const tabAtrr = $activeModal.find('.active').attr('gf-tab');
          const activeTime = Date.now() - startTrackingTime
          if(tabAtrr === 'template'){
            templateTrackingTime += activeTime;
          }
          if(tabAtrr === 'style'){
            styleTrackingTime += activeTime
          }
          if(tabAtrr === 'script'){
            scriptTrackingTime += activeTime
          }
          const labelElement = $element.attr('data-label') || 'Row';
          $activeModal.find('.is-selected').each(function(){
            const tabAtrrItem = jQuery(this).attr('gf-tab');
            let trackingTimeItem = 0
            if(tabAtrrItem === 'template'){
              trackingTimeItem = templateTrackingTime
              templateTrackingTime = 0
            }
            if(tabAtrrItem === 'style'){
              trackingTimeItem = styleTrackingTime
              styleTrackingTime = 0
            }
            if(tabAtrrItem === 'script'){
              trackingTimeItem = scriptTrackingTime
              scriptTrackingTime = 0
            }
            const tabNameItem = jQuery(this).text()
            const gfFrameData = $gfFrame.data('gfframe');

            app.$store.dispatch('common/trackEvent', {
              eventId: EDITOR_EVENT.GS_CUSTOM_CODE_SAVED,
              properties: {
                shop_domain: gfFrameData.getShopDomain(),
                template_page_id: gfFrameData.getPageId(),
                product_element_type: labelElement,
                tab_custom: tabNameItem,
                tab_tracking_time: trackingTimeItem,
              },
          })
          });
          const style = $cEditor.getValue();
          _this.setRowCSS(style);

          HELPER.flagListItemChange($element, 'replace');
          HELPER.detectContentChange($element);

          $activeModal.data('gfmodal').hide();

          // History
          const extra = {
            edit: 'css',
            style: oldStyle,
          };
          if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') != undefined) {
            $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
          }

          return false;
        });
      return false;
    };

    this.getColCSSUseDom = function (colId) {
      const $bkActiveColumn = $divContentBk.find('#column-' + colId);
      const $style = $bkActiveColumn.find('.style');
      let style = $style.html();
      if (!style) {
        style = '';
      }

      return style;
    };

    this.getColCSSUseStore = function (colId) {
      const key = rowTypes._styleColumn + '-' + colId;
      return app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](key);
    };

    this.getColCSS = function (colId) {
      return this.getColCSSUseStore(colId);
    };

    this.setColCSSUseStore = function (colId, style) {
      const _style = HELPER.formatCSS(style);
      const $columnC = $columnStyleContainer.find('#' + base._style + '-' + colId);

      if ($columnC.length === 0) {
        jQuery(`<div id="${base._style}-${colId}"></div>`).appendTo($columnStyleContainer);
      }

      $columnC.html('<style class="style">' + _style + '</style>');
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: rowTypes._styleRow + '-' + colId,
        value: _style,
      });
    };

    this.setColCSSUseDom = function (colId, style) {
      style = HELPER.formatCSS(style);
      const $bkActiveColumn = $divContentBk.find('#column-' + colId);
      const $style = $bkActiveColumn.find('.style');
      $style.html(style);
      return _this;
    };

    this.setColCSS = function (colId, style) {
      return this.setColCSSUseStore();
    };

    this.colCSS = function ($activeColumn, enableSections = ['style']) {
      const colId = $activeColumn.attr('data-id');
      $divContentHidden.find('#md-editor').remove();
      $divContentHidden.append(_mdEditor);
      $divContentHidden.find('[gf-tag="title"]').text(`Edit Column`);

      const style = _this.getColCSS(colId);
      const oldStyle = style;

      const $activeModal = jQuery('#md-editor');
      $activeModal.find('#styleCode').val(HELPER.formatCSS(style));
      $activeModal.find(`[gf-tabs]>[gf-tab="style"]`).addClass('active is-selected');
      const $cEditor = initAce('styleCode', 'style');
      // huỷ trạng thái disable của những tab được active
      $activeModal.find('[gf-tabs]>[gf-tab]').each(function () {
        const $item = jQuery(this);
        const tab = ($item.attr('gf-tab') || '').toLowerCase();
        if (enableSections.includes(tab)) {
          $item.removeClass('disabled');
        }
      });

      $activeModal.gfModal({
        opacity: 0.4,
        bg: 'rgb(62, 62, 62)',
        zIndex: 9999999,
      });

      let __timeout = null;
      // xử lý click vào tag để copy id
      $activeModal
        .find('[gf-action="click:copyToClipboard"]')
        .off('click.clipboard')
        .on('click.clipboard', function () {
          const copied = copyToClipboard($element.attr('data-id'));
          if (copied) {
            const $thisSpan = jQuery(this);
            $thisSpan.parent().find('[gf-span="msg"]').remove();
            clearTimeout(__timeout);
            const $msg = jQuery(`<span gf-span="msg">Copied!</span>`);
            $msg.css({
              color: '#42C184',
              'font-size': '12px',
              'margin-left': '4px',
            });
            $thisSpan.after($msg);
            __timeout = setTimeout(() => {
              $thisSpan.next('span').remove();
            }, 1500);
          }
        });

      const mw = jQuery(window).outerWidth() < 1000 ? jQuery(window).outerWidth() : 1000;

      $activeModal
        .data('gfmodal')
        .setTitle('#' + $element.attr('data-id'))
        .setWidth(mw + 'px')
        // .setHeight('500px')
        .centerModal() //
        .show();

      $activeModal
        .find('.btnSave')
        .off()
        .on('click', function (e) {
          const style = $cEditor.getValue();
          _this.setColCSS(colId, style);

          HELPER.flagListItemChange($element, 'replace');
          HELPER.detectContentChange($element);

          $activeModal.data('gfmodal').hide();

          // History
          const extra = {
            edit: 'css',
            target: 'col',
            style: oldStyle,
            colId: colId,
          };
          if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') != undefined) {
            $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
          }

          return false;
        });
      return false;
    };

    //gfRow.cloneMe
    this.cloneMe = function (removeOrigin, scrollToMe) {
      if (removeOrigin == undefined) {
        var removeOrigin = false;
      }
      if (scrollToMe == undefined) {
        var scrollToMe = true;
      }

      const data = _this.export('clone');

      if (HELPER.isInsideTheList($element)) {
        var html = data.html;
        var bkHtml = data.bkHtml;

        const $tmpHtml = jQuery('<div />').html(html);
        const newIdList = [];

        $tmpHtml.find('[data-label][data-id]').each(function () {
          const oldId = jQuery(this).attr('data-id');
          const matchedString = new RegExp(oldId, 'g');

          var newId = HELPER.MakeIdInsideList($element, 'new');

          let increase = 0;
          while (jQuery.inArray(newId, newIdList) !== -1) {
            var newId = HELPER.MakeIdInsideList($element, 'new', increase);
            increase++;
          }
          newIdList.push(newId);

          html = html.replace(matchedString, newId);
          bkHtml = bkHtml.replace(matchedString, newId);
        });
      } else {
        const rData = HELPER.replaceIds(data.html, data.bkHtml);
        var html = rData.html;
        var bkHtml = rData.bkHtml;
      }

      $element.after(html);
      HELPER.addContentBk(bkHtml);

      const $newRow = $element.next('.gf_row');
      // $newRow.gfRow();
      atom.Init($newRow);

      if (removeOrigin) {
        $element.data('gfrow').doRemoveMe();
      }

      HELPER.flagListItemChange($newRow, 'new');
      // detect element or module change
      const $itemContent = $element.closest('.item-content');
      HELPER.detectContentChange($itemContent);

      HELPER.refreshFrame();

      if (!HELPER.isInsideTheList($newRow)) {
        if (!removeOrigin && scrollToMe) {
          if (
            $newRow.offset().top + $gfFrame.offset().top - $gfFrame.contents().scrollTop() >
            window.innerHeight - 250
          ) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $newRow.offset().top - 80,
              },
              800,
            );
          }
        }
      }

      setTimeout(function () {
        const $currentTargetElement = $newRow;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
        }

        const history = {
          id: $currentTargetElement.attr('id'),
          action: 'add',
          position: position,
        };
        $gryffEditor.trigger('history', history);
      }, 300);

      return $newRow;
    };

    this.getColumnHtmlForExport = function ($column) {
      const $cloneColumn = $column.clone();
      const $columnWrap = jQuery('<div />').html($cloneColumn);

      const html = $columnWrap.html();
      return html;
    };

    // gfColumn.exportMe
    this.exportColumn = function ($column) {
      var html = _this.getColumnHtmlForExport($column);
      let bkHtml = '';

      const $html = jQuery('<div />').html(html);
      var $column = $html.children('.gf_column');
      const colId = $column.attr('data-id');

      if (colId != undefined) {
        const $bkCloneColumn = $divContentBk.find('#column-' + colId).clone();
        $bkCloneColumn.find('.script').each(function () {
          jQuery(this).attr('type', 'text/plain');
        });
        const $bkColumnHtml = jQuery('<div />').html($bkCloneColumn);
        bkHtml += $bkColumnHtml.html();
      }

      $column.find('>.gf_row').each(function () {
        const rowId = jQuery(this).attr('data-id');
        if ($gryffBody.find('#r-' + rowId).length) {
          if ($gryffBody.find('#r-' + rowId).data('gfrow') != undefined) {
            const data = $gryffBody
              .find('#r-' + rowId)
              .data('gfrow')
              .exportMe();

            jQuery(this).replaceWith(data.html);
            bkHtml += data.bkHtml;
          }
        }
      });

      $column.find('>.module-wrap').each(function () {
        const moduleId = jQuery(this).attr('data-id');
        if ($gryffBody.find('#m-' + moduleId).length) {
          if ($gryffBody.find('#m-' + moduleId).data('gfmodule') != undefined) {
            const data = $gryffBody
              .find('#m-' + moduleId)
              .data('gfmodule')
              .exportMe();

            jQuery(this).replaceWith(data.html);
            bkHtml += data.bkHtml;
          }
        }
      });
      $column.find('> .element-wrap').each(function () {
        const elementId = jQuery(this).attr('data-id');
        if ($gryffBody.find('#e-' + elementId).length) {
          if ($gryffBody.find('#e-' + elementId).data('gfelement') != undefined) {
            const data = $gryffBody
              .find('#e-' + elementId)
              .data('gfelement')
              .exportMe();

            jQuery(this).replaceWith(data.html);
            bkHtml += data.bkHtml;
          }
        }
      });
      // --------------------------------------------------------------------
      var html = $html.html();
      html = HELPER.compressHTML(html);
      html = HELPER.simpleHTMLEntities(html);

      const data = {
        html: html,
        bkHtml: bkHtml,
      };
      return data;
    };

    this.getRowHtmlForExport = function () {
      const $cloneRow = $element.clone();
      const $rowWrap = jQuery('<div />').html($cloneRow);

      let html = $rowWrap.html();
      html = HELPER.clearExportedData(html);
      return html;
    };

    // gfRow.exportMe
    this.exportMe = function (exportType) {
      var html = _this.getRowHtmlForExport();
      let bkHtml = '';
      let style = '';
      let script = '';
      let libs = [];
      let fonts = [];

      const $html = jQuery('<div />').html(html);
      const $row = $html.children('.gf_row');
      const rowId = $row.attr('data-id');

      if (rowId != undefined) {
        let $bkCloneRow = '';
        $bkCloneRow = HELPER.mergeDataSetting('row', rowId);
        const $bkRowHtml = jQuery('<div />').html($bkCloneRow);
        bkHtml += $bkRowHtml.html();
        // style + script

        style += HELPER.getStyleDataSetting('row', rowId);
        script += HELPER.getScriptDataSetting('row', rowId);

        const interactionData = app.$store.getters['editor/GET_ANIMATION_INTERACTION_SETTING_BY_KEY'](
          base._interactions + '_' + 'row-' + rowId,
        );
        if (interactionData) {
          script += this.parseInteraction2Scripts($row, _this.getRowId(), interactionData, exportType);
        }
      }

      // export children column
      $row.children('.gf_column').each(function () {
        const colId = jQuery(this).attr('data-id');
        const $bkColumn = jQuery('<div />').html($divContentBk.find('#column-' + colId).clone());
        bkHtml += $bkColumn.html();
        style += $bkColumn.find('.style').html();
      });

      $row.find('>.gf_column >.gf_row').each(function () {
        const rowId = jQuery(this).attr('data-id');
        if ($gryffBody.find('#r-' + rowId).length) {
          if ($gryffBody.find('#r-' + rowId).data('gfrow') != undefined) {
            const data = $gryffBody
              .find('#r-' + rowId)
              .data('gfrow')
              .exportMe(exportType);

            jQuery(this).replaceWith(data.html);
            bkHtml += data.bkHtml;
            style += data.style;
            script += data.script;
            libs = libs.concat(data.libs);
            fonts = fonts.concat(data.fonts);
          }
        }
      });

      $row.find('>.gf_column >.module-wrap').each(function () {
        const moduleId = jQuery(this).attr('data-id');
        if ($gryffBody.find('#m-' + moduleId).length) {
          if ($gryffBody.find('#m-' + moduleId).data('gfmodule') != undefined) {
            const data = $gryffBody
              .find('#m-' + moduleId)
              .data('gfmodule')
              .exportMe(exportType);

            jQuery(this).replaceWith(data.html);
            bkHtml += data.bkHtml;
            style += data.style;
            script += data.script;
            libs = libs.concat(data.libs);
            fonts = fonts.concat(data.fonts);
          }
        }
      });

      $row.find('>.gf_column > .element-wrap').each(function () {
        const elementId = jQuery(this).attr('data-id');
        if ($gryffBody.find('#e-' + elementId).length) {
          if ($gryffBody.find('#e-' + elementId).data('gfelement') != undefined) {
            const data = $gryffBody
              .find('#e-' + elementId)
              .data('gfelement')
              .exportMe(exportType);

            jQuery(this).replaceWith(data.html);
            bkHtml += data.bkHtml;
            style += data.style;
            script += data.script;
            libs = libs.concat(data.libs);
            fonts = fonts.concat(data.fonts);
          }
        }
      });
      // --------------------------------------------------------------------
      var html = $html.html();
      html = HELPER.clearExportedData(html);
      html = HELPER.compressHTML(html);
      html = HELPER.simpleHTMLEntities(html);

      style = HELPER.compressHTML(style);

      if (checkKeyValid('trackingError')) {
        if (!html || !bkHtml) {
          const rowId = _this.getRowId();
          window.trackingError.push(rowId);
        }
      }

      const data = {
        html: html,
        bkHtml: bkHtml,
        style: style,
        script: script,
        libs: libs,
        fonts: fonts,
      };
      return data;
    };

    this.parseInteraction2Scripts = function ($row, rowId, interaction, exportType) {
      let script = '';
      let interactionJSON = {};
      try {
        interactionJSON = JSON.parse(interaction);
      } catch {
        interactionJSON = {};
      }
      if (interactionJSON && interactionJSON.animations) {
        interactionJSON.animations.forEach((e) => {
          try {
            const animationName = e.animation.name;
            const interaction = e.interaction;

            if (exportType != 'clone') {
              if (animationName.includes('_in') && SCROLL_VIEW_KEY.includes(interaction.key)) {
                $row.css('opacity', 0);
              }
              if (animationName.includes('_out')) {
                // Do nothing
              }
            }
            if (interaction) {
              switch (interaction.key) {
                case 'mouse-click':
                  script += `window.__gfAnimate.registerClick(jQuery("#r-${rowId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'mouse-hover':
                  script += `window.__gfAnimate.registerHover(jQuery("#r-${rowId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'mouse-leave':
                  script += `window.__gfAnimate.registerMouseLeave(jQuery("#r-${rowId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'after-page-loaded':
                  script += `window.__gfAnimate.registerPageLoaded(jQuery("#r-${rowId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'scroll-into-view':
                  script += `window.__gfAnimate.registerScroll(jQuery("#r-${rowId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'scrolling-in-view':
                  script += `window.__gfAnimate.registerScrolling(jQuery("#r-${rowId}"), '${JSON.stringify(e)}');`;
                  break;
              }
            }
          } catch {}
        });
      }
      return script;
    };

    this.export = function (exportType) {
      const data = _this.exportMe(exportType);
      return data;
    };

    this.atTheBottom = function () {
      const $nextBlocks = $element.nextAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]');
      if ($nextBlocks.length > 0) {
        return false;
      }
      return true;
    };

    this.moveDown = function (scrollToMe) {
      if (!_this.atTheBottom()) {
        if (scrollToMe == undefined) {
          var scrollToMe = true;
        }

        // update place holder
        const $placeholder = $element.next('.block-placeholder');
        if ($placeholder.length > 0) {
          $placeholder.remove();
        }

        const $nextBlock = $element
          .nextAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]')
          .eq(0);
        let $newPlace = $nextBlock.next('.block-placeholder');
        if ($newPlace.length == 0) {
          $newPlace = jQuery('<div class="block-placeholder" />');
          $nextBlock.after($newPlace);
        }

        // History
        let $itemContent;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $element);
        }

        const history = {
          id: $element.attr('id'),
          action: 'move',
          events: [
            {
              action: 'cut',
              position: position,
            },
          ],
        };
        $gryffEditor.trigger('history', history);

        const $from = $element.closest('.item-content');
        const $to = $element.closest('.item-content');

        const $rHandle = $element.children('.gf-tool-wrap').find('.r-handle');
        $rHandle.data('gfdraggable').manageStop($newPlace, $element, $from, $to);

        if (!HELPER.isInsideTheList($element)) {
          if (scrollToMe) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $element.offset().top - 80,
              },
              800,
            );
          }
        }
      }
    };

    this.atTheTop = function () {
      const $prevBlocks = $element.prevAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]');
      if ($prevBlocks.length > 0) {
        return false;
      }
      return true;
    };

    this.moveUp = function (scrollToMe) {
      if (!_this.atTheTop()) {
        if (scrollToMe == undefined) {
          var scrollToMe = true;
        }

        // update place holder
        const $placeholder = $element.next('.block-placeholder');
        if ($placeholder.length > 0) {
          $placeholder.remove();
        }

        const $prevBlock = $element
          .prevAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]')
          .eq(0);
        let $newPlace = $prevBlock.prev('.block-placeholder');
        if ($newPlace.length == 0) {
          $newPlace = jQuery('<div class="block-placeholder" />');
          $prevBlock.before($newPlace);
        }

        // History
        let $itemContent;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $element);
        }

        const history = {
          id: $element.attr('id'),
          action: 'move',
          events: [
            {
              action: 'cut',
              position: position,
            },
          ],
        };
        $gryffEditor.trigger('history', history);

        const $from = $element.closest('.item-content');
        const $to = $element.closest('.item-content');

        const $rHandle = $element.children('.gf-tool-wrap').find('.r-handle');
        $rHandle.data('gfdraggable').manageStop($newPlace, $element, $from, $to);

        if (!HELPER.isInsideTheList($element)) {
          if (scrollToMe) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $element.offset().top - 80,
              },
              800,
            );
          }
        }
      }
    };

    this.hasParent = function () {
      const $parent = $element.parent().closest('.module-wrap[data-label], .gf_row[data-label]');
      if ($parent.length > 0) {
        const parentName = $parent.attr('data-label');

        if (parentName == 'Product') {
          var limitArr = [
            '(P) Title',
            '(P) Price',
            '(P) Quantity',
            '(P) Image',
            '(P) Image List',
            '(P) Ali Reviews',
            '(P) Stock Counter',
            '(P) Cart Button',
            '(P) View More',
            '(P) Description',
            '(P) Variants',
            '(P) Swatches',
            '(P) Meta',
          ];
        } else if (parentName == 'Article List') {
          var limitArr = ['(A) Title', '(A) Content', '(A) Image', '(A) Date'];
        } else {
          var limitArr = [];
        }

        if (limitArr.length > 0) {
          for (let i = 0; i < limitArr.length; i++) {
            if ($element.find('.module-wrap[data-label="' + limitArr[i] + '"]').length > 0) {
              return false;
            }
          }
        }

        return true;
      }
      return false;
    };

    this.toParent = function (scrollToMe) {
      if (_this.hasParent()) {
        if (scrollToMe == undefined) {
          var scrollToMe = true;
        }

        // update place holder
        const $placeholder = $element.next('.block-placeholder');
        if ($placeholder.length > 0) {
          $placeholder.remove();
        }

        const $parent = $element.parent().closest('.module-wrap[data-label], .gf_row[data-label]');
        let $newPlace = $parent.next('.block-placeholder');
        if ($newPlace.length == 0) {
          $newPlace = jQuery('<div class="block-placeholder" />');
          $parent.after($newPlace);
        }

        // History
        let $itemContent;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $element);
        }

        const history = {
          id: $element.attr('id'),
          action: 'move',
          events: [
            {
              action: 'cut',
              position: position,
            },
          ],
        };
        $gryffEditor.trigger('history', history);

        const $from = $element.closest('.item-content');
        const $to = $element.closest('.item-content');

        const $rHandle = $element.children('.gf-tool-wrap').find('.r-handle');
        $rHandle.data('gfdraggable').manageStop($newPlace, $element, $from, $to);

        if (!HELPER.isInsideTheList($element)) {
          if (scrollToMe) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $element.offset().top - 80,
              },
              800,
            );
          }
        }
      }
    };

    // gfRow.doRemoveMe
    this.doRemoveMe = function (isGotoTab0, historyFlag) {
      HELPER.handleBlankPage();

      if (!isGotoTab0) {
        isGotoTab0 = true;
      }

      // update place holder
      const $placeholder = $element.next('.block-placeholder');
      if ($placeholder.length > 0) {
        $placeholder.remove();
      }

      const $itemContent = $element.closest('.item-content');
      // before delete element
      // backup that element for history
      if (historyFlag == undefined) {
        historyFlag = true;
      }
      if (historyFlag) {
        const $currentTargetElement = $element;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
        }

        const data = _this.export('clone');
        const history = {
          id: $currentTargetElement.attr('id'),
          action: 'delete',
          position: position,
          data: {
            html: data.html,
            bkHtml: data.bkHtml,
          },
        };

        app.$store.commit('editor/DELETE_DATA_SETTING_BY_KEY', {
          keyType: 'row',
          attrId: this.getRowId(),
          data: {
            [base._style]: true,
            [base._template]: true,
            [base._snippet]: true,
            [base._libs]: true,
            [base._data]: true,
            [base._script]: true,
            [base._settings]: true,
            [base._interactions]: true,
            [base._actions]: true,
            [base._actionsStyle]: true,
            [base._templateChildHtml]: true,
            [base._templateChildBkHtml]: true,
          },
        });

        $element.children('.gf_column').each(function () {
          const $that = jQuery(this);
          const colId = _this.getColumnId($that);
          app.$store.commit('editor/DELETE_DATA_SETTING_BY_KEY', {
            keyType: 'column',
            attrId: colId,
            data: {
              [base._style]: true,
              [base._template]: true,
              [base._snippet]: true,
              [base._libs]: true,
              [base._data]: true,
              [base._script]: true,
              [base._settings]: true,
              [base._interactions]: true,
              [base._actions]: true,
              [base._actionsStyle]: true,
              [base._templateChildHtml]: true,
              [base._templateChildBkHtml]: true,
            },
          });
        });

        let $style = $rowStyleContainer.find('#' + base._style + '-' + this.getRowId());
        $style.remove();

        $gryffEditor.trigger('history', history);
      }

      if (!HELPER.isInsideTheList($element)) {
        _this.removeAllChilds($element, 'row', isGotoTab0);
      } else {
        HELPER.flagListItemChange($element, 'delete');
      }

      // detect element or module change
      HELPER.detectContentChange($itemContent);
      HELPER.refreshFrame();

      return false;
    };

    this.deleteDataSettingByKey = function (moduleId, keyType = 'module', payload = {}) {
      // payload không truyền gì là xóa all
      removeElement(moduleId);
      app.$store.commit('editor/DELETE_DATA_SETTING_BY_KEY', {
        keyType: keyType,
        attrId: moduleId,
        data: {
          [base._style]: payload.style ? payload.style : true,
          [base._template]: payload.template ? payload.template : true,
          [base._snippet]: payload.snippet ? payload.snippet : true,
          [base._libs]: payload.libs ? payload.libs : true,
          [base._data]: payload.data ? payload.data : true,
          [base._script]: payload.script ? payload.script : true,
          [base._settings]: payload.settings ? payload.settings : true,
          [base._interactions]: payload.interactions ? payload.interactions : true,
          [base._actions]: payload.actions ? payload.actions : true,
          [base._actionsStyle]: payload.actionsStyle ? payload.actionsStyle : true,
          [base._templateChildHtml]: payload.templateChildHtml ? payload.templateChildHtml : true,
          [base._templateChildBkHtml]: payload.templateChildBkHtml ? payload.templateChildBkHtml : true,
        },
      });
      return false;
    };

    this.removeAllChilds = function ($object, type, isGotoTab0) {
      if (isGotoTab0 == undefined) {
        isGotoTab0 = true;
      }

      const $rowEqualHeight = $object.closest('.gf_equal-height');

      const $elems = $object.find('.element-wrap');
      for (var k = 0; k < $elems.length; k++) {
        const elementId = $elems.eq(k).attr('data-id');
        _this.deleteDataSettingByKey(elementId, 'element');
        const $style = $elementStyleContainer.find('#' + base._style + '-' + elementId);
        $style.remove();
      }

      const $modules = $object.find('.module-wrap');
      for (var k = 0; k < $modules.length; k++) {
        const moduleId = $modules.eq(k).attr('data-id');
        _this.deleteDataSettingByKey(moduleId, 'module');
        const $style = $moduleStyleContainer.find('#' + base._style + '-' + moduleId);
        $style.remove();
        const $script = $moduleScriptContainer.find('#' + base._script + '-' + moduleId);
        $script.remove();
      }

      const $cols = $object.find('.gf_column');
      for (var k = 0; k < $cols.length; k++) {
        var colId = $cols.eq(k).attr('data-id');
        _this.deleteDataSettingByKey(colId, 'column');
        const $style = $columnStyleContainer.find('#' + base._style + '-' + colId);
        $style.remove();
      }

      const $rows = $object.find('.gf_row');
      for (var k = 0; k < $rows.length; k++) {
        var rowId = $rows.eq(k).attr('data-id');
        _this.deleteDataSettingByKey(rowId, 'row');
        const $style = $rowStyleContainer.find('#' + base._style + '-' + rowId);
        $style.remove();
      }

      if (type == 'row') {
        var rowId = _this.getRowId();
        var $bkActiveModule = $divContentBk.find('#row-' + rowId);
        $bkActiveModule.remove();

        $object.remove();
      } else {
        var colId = $object.attr('data-id');
        var $bkActiveModule = $divContentBk.find('#column-' + colId);
        $bkActiveModule.remove();

        $object.remove();
      }

      if ($rowEqualHeight.length > 0) {
        HELPER.refreshEqualHeight();
        HELPER.refreshFrame();
      }

      // reuturn to tab 0
      if (isGotoTab0) {
        $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
      }

      return false;
    };

    this.setColumn = function ($column, type, device, val) {
      if ($column != undefined) {
        if (device !== 'lg' && device !== 'md' && device !== 'sm' && device !== 'xs') {
          device = 'lg';
        }
        if (typeof column === 'string') $column = jQuery(column);
        else if (typeof column === 'object') $column = column;

        if (type === 'size') {
          $column.removeClass(function (index, css) {
            if (device === 'lg') return (css.match(/(^|\s)gf_col-lg-+[0-9]+(?=($|\s))+/g) || []).join(' ');
            else if (device === 'md') return (css.match(/(^|\s)gf_col-md-+[0-9]+(?=($|\s))+/g) || []).join(' ');
            else if (device === 'sm') return (css.match(/(^|\s)gf_col-sm-+[0-9]+(?=($|\s))+/g) || []).join(' ');
            else if (device === 'xs') return (css.match(/(^|\s)gf_col-xs-+[0-9]+(?=($|\s))+/g) || []).join(' ');
          });
          if (val) {
            $column.addClass('gf_col-' + device + '-' + val);
          }
        } else if (type === 'offset') {
          $column.removeClass(function (index, css) {
            if (device === 'lg') return (css.match(/(^|\s)gf_col-lg-offset-+[0-9]+(?=($|\s))+/g) || []).join(' ');
            else if (device === 'md') return (css.match(/(^|\s)gf_col-md-offset-+[0-9]+(?=($|\s))+/g) || []).join(' ');
            else if (device === 'sm') return (css.match(/(^|\s)gf_col-sm-offset-+[0-9]+(?=($|\s))+/g) || []).join(' ');
            else if (device === 'xs') return (css.match(/(^|\s)gf_col-xs-offset-+[0-9]+(?=($|\s))+/g) || []).join(' ');
          });
          if (val) {
            $column.addClass('gf_col-' + device + '-offset-' + val);
          }
        }

        // detect element or module change
        const $itemContent = $element.closest('.item-content');
        HELPER.detectContentChange($itemContent);
      }

      // to update placeholder
      setTimeout(function () {
        $gryffEditor.data('gryffeditor').updatePlaceHolders();
      }, 0);

      return $column;
    };

    this.getColumn = function ($column, type, device) {
      let res = {};
      switch (type) {
        case 'size':
          var regex = new RegExp('(^|\\s)gf_col-' + device + '-+[0-9]+(?=($|\\s))', 'g');
          if ($column.attr('class').match(regex)) {
            var arr = $column.attr('class').match(regex)[0];
            arr = arr.split('-');
            res = {
              type: type,
              screen: device,
              value: arr[arr.length - 1],
            };
          }
          break;

        case 'offset':
          var regex = new RegExp('(^|\\s)gf_col-' + device + '-offset-+[0-9]+(?=($|\\s))', 'g');
          if ($column.attr('class').match(regex)) {
            var arr = $column.attr('class').match(regex)[0];
            arr = arr.split('-');
            res = {
              type: type,
              screen: device,
              value: arr[arr.length - 1],
            };
          }
          break;
      }
      return res;
    };
    this.switchDisplay = function (style, $element, displayType) {
      const deOption = {};
      if (displayType === 'flex') {
        $element.css({ display: 'flex', 'flex-wrap': 'wrap' });
      } else {
        $element.css({ display: 'block', 'flex-wrap': 'unset' });
      }
      const styleUpdate = HELPER.designOptions2Style($element, 'lg', style, deOption);
      _this.runStyle(styleUpdate);
    };
    this.setFlexDirection = function (style, $element, screenType) {
      let deOptionsXS = [],
        deOptionsSM = [],
        deOptionsMD = [],
        deOptionsLG = [];
      const layout = this.getAllRowLayout($element) || {};
      switch (screenType) {
        case 'xs': {
          if (layout.xs == '12') {
            deOptionsXS = [
              {
                key: 'flex-direction',
                value: 'column',
              },
            ];
          } else {
            deOptionsXS = [
              {
                key: 'flex-direction',
                value: 'row',
              },
            ];
          }
          const styleXs = HELPER.designOptions2Style($element, 'xs', style, deOptionsXS);
          _this.runStyle(styleXs);
          break;
        }
        case 'sm': {
          if (layout.sm == '12') {
            deOptionsSM = [
              {
                key: 'flex-direction',
                value: 'column',
              },
            ];
          } else {
            deOptionsSM = [
              {
                key: 'flex-direction',
                value: 'row',
              },
            ];
          }
          const styleSm = HELPER.designOptions2Style($element, 'sm', style, deOptionsSM);
          _this.runStyle(styleSm);
          break;
        }
        case 'md': {
          if (layout.md == '12') {
            deOptionsMD = [
              {
                key: 'flex-direction',
                value: 'column',
              },
            ];
          } else {
            deOptionsMD = [
              {
                key: 'flex-direction',
                value: 'row',
              },
            ];
          }
          const styleMd = HELPER.designOptions2Style($element, 'md', style, deOptionsMD);
          _this.runStyle(styleMd);
          break;
        }
        case 'lg': {
          if (layout.lg == '12') {
            deOptionsLG = [
              {
                key: 'flex-direction',
                value: 'column',
              },
            ];
          } else {
            deOptionsLG = [
              {
                key: 'flex-direction',
                value: 'row',
              },
            ];
          }
          const styleLg = HELPER.designOptions2Style($element, 'lg', style, deOptionsLG);
          _this.runStyle(styleLg);
          break;
        }
      }

      // After setting done for lg (default) (lg will set for all other sreen type including xs => need to checking and setting for xs again)
      setTimeout(() => {
        if (layout.xs == '12') {
          deOptionsXS = [
            {
              key: 'flex-direction',
              value: 'column',
            },
          ];
          const styleXs = HELPER.designOptions2Style($element, 'xs', style, deOptionsXS, '', false);
          _this.runStyle(styleXs);
        }
      }, 500);
    };
    this.getKeyDataSetting = function (keyType, rowId, type = 'row') {
      const key = `${keyType}-${type}-${rowId}`;
      return key;
    };
    this.init();
  };
  jQuery.fn.gfRow = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfrow')) {
        const plugin = new jQuery.gfRow(this, options);
        jQuery(this).data('gfrow', plugin);
      }
    });
  };
})(jQuery);
